<div class="container container-shadow my-4">
  <h2 class="pt-4 text-center">New Vendor</h2>
  <hr class="mt-1 mb-4" />
  <div class="row">
    <div class="col-md-10 ml-md-auto mr-md-auto col-lg-8 px-md-0 px-sm-3">
      <app-vendor-form></app-vendor-form>
    </div>
  </div>
</div>
